// extracted by mini-css-extract-plugin
module.exports = {"row":"row--_ZbHdN","label":"label--e3TCE2","box":"box--QMKx65","selected":"selected--qgkatU"};